export default "__VITE_ASSET__70c456b4__"